import { CLEAR_TAKE_PAYMENT_DETAILS, SAVE_TAKE_PAYMENT_DETAILS } from "../../constants/take-payment/take-payment-constants"


const initialState = {
    paymentDetails: null,
    originalAmount: 0,
    totalAmount: 0,
    tipAmount: 0,
    bookingFees: 0,
    originalAmountIncludingBookingFees: 0,
    noShowFees: 0
}
export const TakePaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_TAKE_PAYMENT_DETAILS:
            return {
                ...state,
                ...action.payload,
            }
        case CLEAR_TAKE_PAYMENT_DETAILS:
            return {
                ...state,
                paymentDetails: null,
                originalAmount: 0,
                totalAmount: 0,
                tipAmount: 0,
                bookingFees: 0,
                originalAmountIncludingBookingFees: 0,
                noShowFees: 0
            }
        default:
            return state
    }
}  